"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
require("./Articles.scss");
var semantic_ui_react_1 = require("semantic-ui-react");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var react_cookie_1 = require("react-cookie");
var moment_1 = __importDefault(require("moment"));
var react_helmet_1 = __importDefault(require("react-helmet"));
var swiper_1 = __importStar(require("swiper"));
var react_2 = require("swiper/react");
require("swiper/swiper.scss");
require("swiper/components/navigation/navigation.scss");
require("swiper/components/scrollbar/scrollbar.scss");
require("swiper/components/pagination/pagination.min.css");
var helperFunctions_1 = require("../../util/helperFunctions");
var Feed_1 = __importDefault(require("../../util/feed/Feed"));
var actions = __importStar(require("./articlesActions"));
var followActions = __importStar(require("../following/FollowingActions"));
var SideControl_1 = __importDefault(require("../components/SideControl"));
//import * as api from './articlesApi';
var Footer_1 = __importDefault(require("../../footer/Footer"));
var Articles = /** @class */ (function (_super) {
    __extends(Articles, _super);
    function Articles(props) {
        var _this = this;
        swiper_1.default.use([swiper_1.Navigation, swiper_1.Scrollbar, swiper_1.Pagination, swiper_1.Autoplay]);
        _this = _super.call(this, props) || this;
        _this.componentDidUpdate = function (prevProps, prevState) {
            var _a = _this.props, isLoadingFollowers = _a.isLoadingFollowers, userInfo = _a.userInfo, following = _a.following;
            if (prevProps.isLoadingFollowers == isLoadingFollowers &&
                prevProps.userInfo.id != userInfo.id) {
                _this.getFollowingAndFollowers();
            }
            if (prevProps.following != following) {
                _this.selectFavourites();
            }
            /*
            if (acfData && currentAuthorQuery?.length === 0 && tabName == 'Latest') {
              this.sortOfficalAuthor();
            }
            */
        };
        /*
        sortOfficalAuthor() {
          const { acfData } = this.state;
          const query = acfData.authors.map(({ id }) => [id]);
          this.setState({ currentAuthorQuery: query });
        }
        */
        _this.getFollowingAndFollowers = function () {
            var _a = _this.props, getFollowing = _a.getFollowing, getFollowers = _a.getFollowers, userInfo = _a.userInfo;
            userInfo.id &&
                getFollowing({
                    userId: userInfo.id,
                    page: 1,
                });
            userInfo.id &&
                getFollowers({
                    userId: userInfo.id,
                    page: 1,
                });
        };
        _this.addFavoriteCategory = function (categoryId) {
            var _a = _this.props, cookies = _a.cookies, addFavoriteCategory = _a.addFavoriteCategory;
            var token = cookies.get("trybe_jwt");
            addFavoriteCategory({ category: categoryId, token: token });
        };
        _this.deleteFavoriteCategory = function (categoryId) {
            var _a = _this.props, cookies = _a.cookies, deleteFavoriteCategory = _a.deleteFavoriteCategory;
            var token = cookies.get("trybe_jwt");
            deleteFavoriteCategory({ category: categoryId, token: token });
        };
        _this.addCategory = _this.addCategory.bind(_this);
        _this.deleteCategory = _this.deleteCategory.bind(_this);
        _this.selectAll = _this.selectAll.bind(_this);
        _this.selectFavourites = _this.selectFavourites.bind(_this);
        _this.selectTerraNews = _this.selectTerraNews.bind(_this);
        _this.updateCategoriesQuery = Articles.updateCategoriesQuery;
        _this.updateAuthorsQuery = Articles.updateAuthorsQuery;
        _this.state = {
            currentAuthorQuery: [],
            currentCategoryQuery: [],
            orderQuery: "",
            categoriesState: "all",
            // tabName: 'Latest',
            getPromos: "",
            acfData: null,
            hideFeedMenu: false,
            feedTabsEnabled: false,
        };
        return _this;
    }
    Articles.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var getPromos, promoCache, pageName, tabStatus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, helperFunctions_1.setPageForGoogleAnalytics)("your-trybe/articles");
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            event: "community_view",
                            event_category: "page",
                            event_action: "community_view",
                        });
                        getPromos = this.props.getPromos;
                        promoCache = JSON.parse(localStorage.getItem("trybe_promos"));
                        pageName = window.location.pathname;
                        tabStatus = localStorage.getItem("tabName");
                        if (!(!promoCache && pageName == "/community/")) return [3 /*break*/, 2];
                        return [4 /*yield*/, getPromos()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!(promoCache && pageName == "/community/")) return [3 /*break*/, 4];
                        this.setState({ getPromos: promoCache });
                        return [4 /*yield*/, getPromos()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (tabStatus) {
                            this.handleOrderChange(tabStatus);
                        }
                        else {
                            if (this.props.userInfo && this.props.userInfo.id) {
                                this.handleOrderChange("Feed");
                            }
                            else {
                                this.handleOrderChange("Latest");
                            }
                        }
                        this.getFollowingAndFollowers();
                        return [2 /*return*/];
                }
            });
        });
    };
    Articles.prototype.addCategory = function (category) {
        var _this = this;
        var categoriesState = this.state.categoriesState;
        categoriesState === "favorites" && this.addFavoriteCategory(category.id);
        this.setState(function (state) {
            var chosenCategories = state.chosenCategories;
            var newCategories = __spreadArray(__spreadArray([], chosenCategories, true), [category], false);
            var query = _this.updateCategoriesQuery(newCategories);
            return {
                chosenCategories: newCategories,
                currentAuthorQuery: query,
            };
        });
    };
    Articles.prototype.deleteCategory = function (category) {
        var _this = this;
        var categoriesState = this.state.categoriesState;
        categoriesState === "favorites" && this.deleteFavoriteCategory(category.id);
        this.setState(function (state) {
            var chosenCategories = state.chosenCategories;
            var newChosenCategories = chosenCategories.filter(function (_a) {
                var id = _a.id;
                return id != category.id;
            });
            var query = _this.updateCategoriesQuery(newChosenCategories);
            return {
                chosenCategories: newChosenCategories,
                currentAuthorQuery: query,
            };
        });
    };
    Articles.prototype.selectFavourites = function () {
        var following = this.props.following;
        var authors = following.map(function (data) { return data.person; });
        this.setState({
            categoriesState: "favorites",
            currentAuthorQuery: this.updateAuthorsQuery(authors),
            currentCategoryQuery: [],
        });
    };
    Articles.prototype.selectTerraNews = function () {
        this.setState({
            categoriesState: "all",
            currentAuthorQuery: [],
            //currentCategoryQuery: this.updateCategoriesQuery(preChosenCategories),
            currentCategoryQuery: [],
        });
    };
    Articles.prototype.selectAll = function () {
        this.setState({
            categoriesState: "all",
            currentAuthorQuery: [],
            currentCategoryQuery: [],
        });
    };
    Articles.updateAuthorsQuery = function (authors) {
        var query = authors[0] ? authors.map(function (_a) {
            var id = _a.id;
            return id;
        }).join(",") : null;
        return query;
    };
    Articles.updateCategoriesQuery = function (chosenCategories) {
        var query = chosenCategories[0]
            ? chosenCategories.map(function (_a) {
                var id = _a.id;
                return id;
            }).join(",")
            : null;
        return query;
    };
    // _extractPreChosenCategories(categories = []) {
    //   const {preChosenCategories, categories} = this.props;
    //   preChosenCategories.forEach((category) => {
    //     categories.push(category);
    //     if (category.subCategories[0] ) {
    //       this._extractPreChosenCategories(category.subCategories);
    //     }
    //   });
    //   return categories;
    // }
    Articles.prototype.handleOrderChange = function (value) {
        localStorage.setItem("tabName", value);
        //document.querySelector('.app-body').scrollTo(0, 0);
        // 30 Days
        var month = (0, moment_1.default)()
            .subtract(30, "days")
            .toString();
        var month_date = new Date(month);
        // Week
        var week = (0, moment_1.default)()
            .subtract(7, "days")
            .toString();
        var week_date = new Date(week);
        // Today
        var today = (0, moment_1.default)()
            .subtract(1, "day")
            .toString();
        //const today_date = new Date(today);
        this.setState({ tabName: value });
        if (value === "Feed") {
            this.selectFavourites();
            this.setState({ orderQuery: "" });
        }
        else if (value === "Latest") {
            //this.selectTerraNews();
            this.setState({ orderQuery: "&role=author" });
            this.selectAll();
        }
        else if (value === "Today") {
            this.setState({ orderQuery: "" });
            this.selectAll();
        }
        else if (value === "Week") {
            this.setState({
                orderQuery: "&after=".concat(week_date.toISOString(), "&orderby=token_score_average"),
            });
            this.selectAll();
        }
        else if (value === "Month") {
            this.setState({
                orderQuery: "&after=".concat(month_date.toISOString(), "&orderby=token_score_average"),
            });
            this.selectAll();
        }
        else if (!value) {
            this.setState({ orderQuery: "" });
            this.selectAll();
        }
        if (this.state.hideFeedMenu) {
            this.setState({ tabName: null });
            this.toggleFeedMenu(false);
        }
    };
    Articles.prototype.toggleFeedMenu = function () {
        this.setState({ hideFeedMenu: this.state.hideFeedMenu ? false : true });
    };
    Articles.prototype.render = function () {
        var _a = this.props, promos = _a.promos, userInfo = _a.userInfo, acctName = _a.acctName, following = _a.following, followers = _a.followers, isLoadingFollowers = _a.isLoadingFollowers;
        var _b = this.state, currentCategoryQuery = _b.currentCategoryQuery, currentAuthorQuery = _b.currentAuthorQuery, orderQuery = _b.orderQuery, tabName = _b.tabName, getPromos = _b.getPromos, hideFeedMenu = _b.hideFeedMenu, isFeedFollowers = _b.isFeedFollowers;
        var promoData = getPromos ? getPromos : promos;
        var history = this.props.history;
        var follow_count = {
            following: following.length,
            followers: followers.length,
        };
        //tabName == 'Feed' && !isLoadingFollowers && currentAuthorQuery && console.log("LOL")
        //tabName == 'Feed' && !isLoadingFollowers && currentAuthorQuery && console.log(currentAuthorQuery)
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Grid, __assign({ className: "promo", style: { marginTop: "100px" } }, { children: [(0, jsx_runtime_1.jsx)(react_helmet_1.default, { children: (0, jsx_runtime_1.jsx)("title", { children: "Loop Fans | Blog" }) }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid, __assign({ className: "page-wrapper" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "content-wrapper" }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid, __assign({ className: "c-row" }, { children: (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.GridColumn, __assign({ computer: 11, mobile: 16, tablet: 16, className: "bg-info cz-set-new-blog" }, { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid, __assign({ className: "tab-article" }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.List, __assign({ link: true, inverted: true, className: "post_tabs" }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.List.Item, __assign({ as: "a", className: "nav-link" }, { children: (0, jsx_runtime_1.jsx)("span", { children: "Loop Fans Blog" }) })) })) })), (0, jsx_runtime_1.jsx)(Feed_1.default, { tabName: tabName, queryParams: "&categories=10211&cache=true" })] })) })) })) }))] })) }));
    };
    return Articles;
}(react_1.PureComponent));
exports.default = (0, react_cookie_1.withCookies)((0, react_router_dom_1.withRouter)((0, react_redux_1.connect)(function (state, ownProps) {
    return {
        acctName: state.user.userInfo.eosAccount,
        currentCategory: state.articles.currentCategory,
        isAuthorized: state.user.userIsLogged,
        userInfo: state.user.userInfo,
        followers: state.following.followers,
        following: state.following.following,
        isLoadingFollowers: state.following.loadingList,
        isLoadingSubscription: state.following.loadingSubscribe,
        loadingIndexes: state.following.loadingIndexes,
        categories: state.articles.categories,
        promos: state.articles.promos,
        powerUpData: state.powerUp,
        postsData: state.feed.posts,
        cookies: ownProps.cookies,
    };
}, function (dispatch) { return ({
    getPromos: function () { return dispatch(actions.getAllPromos()); },
    addFavoriteCategory: function (params) {
        return dispatch(actions.addFavoriteCategory(params));
    },
    deleteFavoriteCategory: function (params) {
        return dispatch(actions.deleteFavoriteCategory(params));
    },
    getFollowing: function (params) {
        dispatch(followActions.getFollowing(params));
    },
    getFollowers: function (params) {
        dispatch(followActions.getFollowers(params));
    },
}); })(Articles)));
